import AXIOS from '@/utils/$axios';

// 装修方案list
export const getProjectList = data =>
    AXIOS.post('/space/scheme/design/list', data);

// 项目详情
export const getProjecDetail = data =>
    AXIOS.post('/space/project/project/detail', data);

// 项目管理

export const getProjectSpace = data =>
    AXIOS.post('/space/project/project/space', data);

// 项目详情 图文方案
export const getProjectImageText = data =>
    AXIOS.post('/space/project/project/image-text', data);

// 项目详情 3视图
export const getProject3Views = data =>
    AXIOS.post('/space/project/project/image-effect', data);

// 项目详情  施工图

export const getProjectImageBuild = data =>
    AXIOS.post('/space/project/project/image-build', data);

// 项目详情  施工进度

export const getProjectStep = data =>
    AXIOS.post('/space/project/project/build-step', data);

// 项目详情  预算清单 概况
export const getBudgetPrivew = data =>
    AXIOS.post('/space/project/project/budget-view', data);

// 项目详情 预算清单 工程项目
export const getProject = data =>
    AXIOS.post('/space/project/project/item', data);

// 项目详情 预算清单  辅材

export const getAuxiliaryMaterial = data =>
    AXIOS.post('/space/project/project/assist', data);

// 项目详情 预算清单 硬装主材

export const getHardMountingMaterials = data =>
    AXIOS.post('/space/project/project/strong', data);

// 项目详情 预算清单 家具软装

export const getUpholsteredFurniture = data =>
    AXIOS.post('/space/project/project/furniture', data);

// 删除装修方案

export const deleteScheme = data => AXIOS.post('/space/scheme/delete', data);

//装修方案 分享给我的
export const schemeDiscard = data =>
    AXIOS.post('/space/scheme/design/scheme-share-list', data);

// 回收站 恢复
export const schemeReply = data => AXIOS.post('/space/scheme/reply', data);

// 装修方案复制
export const schemeCopy = data => AXIOS.post('/space/scheme/design/copy', data);

// 装修方案删除
export const schemeDelete = data =>
    AXIOS.post('/space/scheme/design/delete', data);

// 装修方案 获取分享链接
export const getSchemeShareUrl = data =>
    AXIOS.post('/space/scheme/design/share', data);

// 装修方案 获取分享方案详情
export const getSchemeShareDetail = data =>
    AXIOS.post('/space/scheme/design/scheme-share-info', data);

// 装修方案 重命名

export const schemeRename = data =>
    AXIOS.post('/space/scheme/design/rename', data);
